import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";

const resources = {
  en: {
    translation: en,
  },
};

const initOptions = {
  resources,
  lng: "en", // Always use English
  fallbackLng: "en",
  keySeparator: ".",
  interpolation: {
    escapeValue: false,
  },
};

// During HMR / re-imports, i18n may already be initialized. In that case, merge
// new keys so the UI doesn’t show raw translation keys until a full reload.
if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init(initOptions);
} else {
  i18n.addResourceBundle("en", "translation", en, true, true);
}

if (!i18n.__beatlyLanguageListenerAdded) {
  i18n.__beatlyLanguageListenerAdded = true;
  i18n.on("languageChanged", (lng) => {
    localStorage.setItem("language", lng);
  });
}

// Vite HMR: when `en.json` changes, merge it into i18n immediately.
// This prevents the UI from showing raw translation keys until a full restart.
if (import.meta?.hot) {
  import.meta.hot.accept("./locales/en.json", (mod) => {
    const nextEn = mod?.default ?? mod;
    if (nextEn) {
      i18n.addResourceBundle("en", "translation", nextEn, true, true);
    }
  });
}

export default i18n;
